import React from 'react';
import { Link } from 'react-router-dom';

const CourseCard = ({ course }) => {
    return (
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg transition-all duration-300 hover:shadow-2xl hover:scale-[1.02]">
            {/* Container da Imagem */}
            <div className="relative w-full h-48 bg-gray-200">
                <img 
                    src={course.image} 
                    alt={course.title}
                    className="w-full h-full object-cover"
                    style={course.imagePosition ? { objectPosition: course.imagePosition } : undefined}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=1000&q=80';
                    }}
                />
            </div>
            
            {/* Conteúdo do Card */}
            <div className="p-6 bg-white">
                {/* Badge */}
                <div className="mb-3">
                    <span className="inline-block bg-orange-100 text-orange-700 text-xs font-bold px-3 py-1.5 rounded uppercase tracking-wide">
                        Formação de Socorristas
                    </span>
                </div>
                
                {/* Título */}
                <h2 className="font-bold text-2xl text-gray-900 mb-3">{course.title}</h2>
                
                {/* Descrição */}
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{course.description}</p>
                
                {/* Link/Botão */}
                <Link 
                    to={`/courses/${course.id}`} 
                    className="inline-flex items-center text-orange-600 hover:text-orange-700 font-semibold text-sm transition-colors"
                >
                    Saiba mais
                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </Link>
            </div>
        </div>
    );
};

export default CourseCard;